import React, { useState } from 'react';
import { FaStethoscope, FaClinicMedical, FaUserMd, FaHeartbeat } from 'react-icons/fa';

const Facility= () => {
  const [activeCard, setActiveCard] = useState(null);

  const cancerTypes = [
    {
      title: "प्रोस्टेट कैंसर",
      englishTitle: "Prostate Cancer",
      image: "https://medicaldialogues.in/h-upload/2020/02/29/124937-prostate-cancer-2.jpg",
      description: "Advanced treatment for prostate cancer with minimally invasive techniques",
      symptoms: ["Urinary difficulties", "Blood in semen", "Erectile dysfunction", "Pelvic pain"],
      treatments: ["Robotic Surgery", "Radiation Therapy", "Hormone Therapy", "Chemotherapy"]
    },
    {
      title: "एंड्रो कैंसर (टेस्टिकल)",
      englishTitle: "Testicular Cancer",
      image: "https://images.onlymyhealth.com/imported/images/2023/February/03_Feb_2023/Endometrial-Cancer-Ke-Lakshan.jpg",
      description: "Comprehensive care for testicular cancer with high success rates",
      symptoms: ["Lump in testicle", "Testicular pain", "Heaviness in scrotum", "Back pain"],
      treatments: ["Orchiectomy", "Radiation", "Chemotherapy", "Surveillance"]
    },
    {
      title: "मूत्राशय एवं मूत्र मार्ग कैंसर",
      englishTitle: "Bladder & Urinary Tract Cancer",
      image: "https://images.ladbible.com/resize?type=webp&quality=70&width=1920&fit=contain&gravity=auto&url=https://images.ladbiblegroup.com/v3/assets/bltcd74acc1d0a99f3a/blt259774e6373d7c9d/66deee6e076912d6fe0f3712/anal-cancer-signs-symptoms.jpg",
      description: "Advanced diagnosis and treatment for bladder and urinary tract cancers",
      symptoms: ["Blood in urine", "Painful urination", "Frequent urination", "Back pain"],
      treatments: ["TURBT", "Cystectomy", "Immunotherapy", "Radiation"]
    },
    {
      title: "गुर्दे (किडनी) का कैंसर",
      englishTitle: "Kidney Cancer",
      image: "https://d2jx2rerrg6sh3.cloudfront.net/image-handler/ts/20250206080112/ri/1950/src/images/news/ImageForNews_801908_17388900552017184.jpg",
      description: "Specialized kidney cancer treatment preserving kidney function",
      symptoms: ["Blood in urine", "Flank pain", "Unexplained weight loss", "Fatigue"],
      treatments: ["Nephrectomy", "Partial Nephrectomy", "Ablation", "Targeted Therapy"]
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-white to-blue-50/50">
      <div className="container mx-auto px-4">
        
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <div className="inline-flex items-center mb-4 px-4 py-2 bg-gradient-to-r from-sky-50 to-red-50 rounded-full">
            <FaStethoscope className="text-red-500 mr-2" />
            <span className="text-sm font-medium text-sky-600">Urological Oncology</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            यूरोलॉजी से संबंधित सभी प्रकार के कैंसर का सही इलाज पाएं!
          </h2>
          <p className="text-gray-600 text-lg">
            Advanced treatment for all urological cancers with modern technology and expertise
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {cancerTypes.map((cancer, index) => (
            <div 
              key={index}
              className={`bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer
                ${activeCard === index ? 'ring-2 ring-sky-500' : ''}`}
              onClick={() => setActiveCard(activeCard === index ? null : index)}
              onMouseEnter={() => setActiveCard(index)}
              onMouseLeave={() => setActiveCard(null)}
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={cancer.image}
                  alt={cancer.title}
                  className="w-full h-full object-cover transition-transform duration-700 hover:scale-110"
                  onError={(e) => {
                    e.target.src = `https://via.placeholder.com/400x300/0ea5e9/ffffff?text=${encodeURIComponent(cancer.englishTitle)}`;
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-xl font-bold text-white mb-1">{cancer.title}</h3>
                  <p className="text-white/90 text-sm">{cancer.englishTitle}</p>
                </div>

              </div>

              <div className="p-5">
                <p className="text-gray-700 text-sm mb-4">{cancer.description}</p>

                <div>
                  <div className="flex items-center mb-2">
                    <FaClinicMedical className="text-sky-500 mr-2 text-sm" />
                    <h4 className="text-sm font-semibold text-gray-800">Available Treatments</h4>
                  </div>
                  <div className="flex flex-wrap gap-1">
                    {cancer.treatments.map((treatment, i) => (
                      <span key={i} className="inline-block px-2 py-1 bg-sky-50 text-sky-700 rounded text-xs">
                        {treatment}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4">
            <a
              href="tel:+918002280222"
              className="px-8 py-3 bg-gradient-to-r from-sky-500 to-sky-600 text-white font-bold rounded-full hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center"
            >
              <FaClinicMedical className="mr-2" />
              Book Cancer Consultation
            </a>
            <a
              href="#contact"
              className="px-8 py-3 bg-white text-sky-600 border-2 border-sky-500 font-bold rounded-full hover:bg-sky-50 transform hover:scale-105 transition-all duration-300 flex items-center"
            >
              <FaUserMd className="mr-2" />
              Second Opinion
            </a>
          </div>
          <p className="text-gray-600 text-sm mt-4">
            Early detection is key - Book your screening today
          </p>
        </div>
      </div>
    </section>
  );
};

export default Facility;